var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.computedTagGroups),function(tags,type){return _c('span',{key:("group-" + type)},_vm._l((tags),function(tag,index){return _c('span',{key:(tag + "-" + index)},[_c('action-tag',{attrs:{"tag":tag}})],1)}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }